import styled from 'styled-components'
import Radio from '@material-ui/core/Radio';

const StyledRadioField = styled(Radio)`
  height: 50px;
  opacity: 0.7;
  padding: 0px !important;
  ${({radioColor}) => `
    color: ${radioColor} !important;

    &:after {
      width: 22px;
      height: 22px;
      border-radius: 100%;
      top: 14px;
      left: 2px;
      position: absolute;
      content: '';
      display: inline-block;
      visibility: visible;
      border: none;
      background-color: ${radioColor};
    }

  `}


  &.MuiFormControlLabel-label {
    display: none;
  }


  &.MuiRadio-colorSecondary.Mui-checked {
    ${({radioColor}) => `
      color: ${radioColor};
    `}
  }

  &:hover {
    background-color: transparent !important;
    opacity: 1;
  }

  &.MuiRadio-colorSecondary.Mui-checked:hover {
    background-color: transparent !important;
  }

  .MuiFilledInput-underline:before{
    border-bottom: 1px solid transparent;
  }

  .MuiFormGroup-root {

    display: inline-block;
    flex-wrap: wrap;
    flex-direction: column;

}
`

StyledRadioField.defaultProps = {
  variant: 'outlined',
}

export default StyledRadioField